import { INPUTCOL, MINCOL } from "../../../constants/const"
import ZeileLöschenLD from "../../Datenerfassung/Bearbeitung/ZeileLöschenLD";
import DeChecks from "../../Datenerfassung/DeChecks";
import CommentCellDatenerfassung from "../CommentCellDatenerfassung";
import EditableCell from "../EditableCell";
import DropdownFilter from "../SD_einsehen/DropdownFilter"
import NoFilterButUnit from "../SD_einsehen/NoFilter";

export const liniendatenHeader = [
    {accessor: 'jahr',
    Header: 'Jahr',
    width: MINCOL},
    {accessor: 'vertrag',
    Header: 'Verkehrsvertrag',
    width: '12em',
    Filter: DropdownFilter},
    {accessor: 'vvArt',
    Header: 'Vertragsart',
    width: MINCOL},
    {accessor: 'verband',
    Header: 'Zweckverband',
    width: MINCOL,
    Filter: DropdownFilter},
    {accessor: 'linie',
    Header: 'Linie',
    width: MINCOL,
    Filter: DropdownFilter},
    {accessor: 'produkt',
    Header: 'Produkt',
    width: MINCOL},
    {accessor: 'zugkilometer',
    Header: 'Zugkilometer',
    width: INPUTCOL,
    Cell: EditableCell,
    Filter: NoFilterButUnit},
    {accessor: 'zuschuss',
    Header: 'Zuschussbedarf',
    width: INPUTCOL,
    Cell: EditableCell,
    Filter: NoFilterButUnit},
    {accessor: 'trassen',
    Header: 'Trassenentgelte',
    width: INPUTCOL,
    Cell: EditableCell,
    Filter: NoFilterButUnit},
    {accessor: 'station',
    Header: 'Stationsentgelte',
    width: INPUTCOL,
    Cell: EditableCell,
    Filter: NoFilterButUnit},
    {accessor: 'minder',
    Header: 'Minderleistungen/Pönalen',
    width: INPUTCOL,
    Cell: EditableCell,
    Filter: NoFilterButUnit},
    {accessor: 'kommentar',
    Header: 'Kommentar',
    width: '12em',
    Cell: CommentCellDatenerfassung,
    Filter: NoFilterButUnit},
    {accessor: 'status',
    Header: 'Status',
    Filter: DropdownFilter,
    width: MINCOL},
    {accessor: 'checked',
    Header: 'Status ändern',
    Cell: DeChecks,
    width: MINCOL},
    {accessor: 'del',
    Header: 'Löschen',
    Cell: ZeileLöschenLD
    }
];

export const hiddenColumns = ['vvlpId', 'id', 'vvId', 'zvId', 'linieId', 'prodId', 'statusEnum'];

export const ldCsvHeader = [
    {key: 'code',
    label: 'Schluessel'},
    {key: 'jahr',
    label: 'Jahr'},
    {key: 'vertrag',
    label: 'Verkehrsvertrag'},
    {key: 'verband',
    label: 'Zweckverband'},
    {key: 'linie',
    label: 'Linie'},
    {key: 'zugkilometer',
    label: 'Zugkilometer'},
    {key: 'zuschuss',
    label: 'Zuschussbedarf'},
    {key: 'trassen',
    label: 'Trassenentgelte'},
    {key: 'station',
    label: 'Stationsentgelte'},
    {key: 'minder',
    label: 'Minderleistungen/Pönalen'},
    {key: 'kommentar',
    label: 'Kommentar'},
    {key: 'status',
    label: 'Status'}];